import React from "react";
import { Paper } from "@mui/material";
import { CloudMap } from "./cloudarch/CloudMap";
import { OnPremMap } from "./onprem/OnPremMap";

// Interactive maps instead of markdown: application architecture on top, on-premises servers below
export const Arquitecture = () => (
  <Paper sx={{ p: 2, width: "100%" }}>
    <CloudMap />
    <OnPremMap />
  </Paper>
);
